import SliderComp from "@components/ui/slider";
import { Checkbox } from "@mui/material";
import { ChevronLeft, CircleAlert, X } from "lucide-react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store"; // Adjust the path as needed
import {
  updateCompanyProfile,
  updateDataCompleteness,
} from "@redux/slices/filter"; // Adjust the path as needed
import { CompanyProfileFilters } from "@/types/filters";
import { useEffect, useState } from "react";
import { Button } from "@components/ui/button";

import {useRecoilState } from "recoil";
import { FilterAtom } from "@/App";

interface Props {
  handleClose: () => void;
}

const CompanyProfile: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialData = {
    requirements: {
      websiteAvailable: false,
      phoneNumberAvailable: false,
      emailAddressAvailable: false,
      vatNumberAvailable: false,
      registerNumberAvailable: false,
    },
    socialMedia: {
      linkedIn: false,
      xing: false,
      facebook: false,
      twitter: false,
      youtube: false,
      instagram: false,
      pinterest: false,
    },
    dataCompleteness: 0, // Default value
  };

  const initialProfile = useSelector(
    (state: RootState) =>
      state?.filter?.companyFilters?.companyProfile || initialData
  );

  const [profile, setProfile] = useState(initialProfile);

  useEffect(() => {
    setProfile(initialProfile);
    console.log("Profile state updated:", profile);
  }, [initialProfile]);

  const handleCheckboxChange = (
    section: keyof Omit<CompanyProfileFilters, "dataCompleteness">,
    key: string,
    value: boolean
  ) => {
    const updatedProfile = {
      ...profile,
      [section]: {
        ...profile[section],
        [key]: value,
      },
    };
    setProfile(updatedProfile);
    dispatch(updateCompanyProfile(updatedProfile));
  };

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      setProfile({ ...profile, dataCompleteness: newValue });
      dispatch(updateDataCompleteness(newValue));
    }
  };

  
  const [filter, setFilter] = useRecoilState(FilterAtom);

  const handleClick = (id: string) => {
    console.log("now clicked is " + id);
    // setClickedIds((prevStrings) => [...prevStrings, id]);
    setFilter((prevFilters: string[]) => [...prevFilters, id]); // Append to the atom
    console.log("I am here now");
  };

  return (
    <div className="p-8">
      <div className="flex justify-between items-center mb-5">
        <h4 className="text-xl font-bold flex items-center -ms-2">
          <ChevronLeft
            size={22}
            className="me-3 cursor-pointer"
            onClick={() => navigate(-1)}
          />
          Company Profile Completeness
        </h4>
        <X onClick={handleClose} className="cursor-pointer" />
      </div>
      <div className="flex gap-4">
        <div className="bg-white w-1/2 rounded-lg px-6 py-4">
          <h4 className="text-lg font-bold flex items-center mb-4">
            Requirements
          </h4>
          {profile?.requirements &&
            Object.entries(profile?.requirements).map(([key, value]) => (
              <div
                key={key}
                className={`flex items-end text-sm justify-between font-medium cursor-pointer text-[#71717A]  ${key === "registerNumberAvailable" ? "border-0" : "border-[1px]"} border-x-0 border-t-0 border-[#DBDBDB] ${
                  key === "websiteAvailable" ? "pb-2" : "pt-2 pb-2"
                }`}
              >
                <h6 className="ms-1">
                  {key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase())}
                </h6>
                <Checkbox
                  checked={value as boolean}
                  onChange={(e) =>
                    handleCheckboxChange("requirements", key, e.target.checked)
                  }
                  sx={{   color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}
                />
              </div>
            ))}
          <h4 className="text-lg font-bold mb-4 mt-6">Data Completeness</h4>
          <SliderComp
            value={profile.dataCompleteness}
            onChange={handleSliderChange}
          />
          <div className="flex text-sm items-center gap-1 pt-3 text-[#71717A]">
            <CircleAlert size={20} />
            The higher the percentage, the more complete the profiles
          </div>
        </div>
        <div className="bg-white w-1/2 rounded-lg h-fit px-6 py-4">
          <h4 className="text-lg font-bold mb-4">Social Media Accounts</h4>
          {profile?.socialMedia &&
            Object.entries(profile?.socialMedia).map(([key, value]) => (
              <div
                key={key}
                className={`flex items-end text-sm justify-between font-medium cursor-pointer text-[#71717A] ${key === "pinterest" ? "border-0" : "border-[1px]"} border-x-0 border-t-0 border-[#DBDBDB] ${
                  key === "linkedIn" ? "pb-2" : "pt-2 pb-2"
                }`}
              >
                <h6 className="ms-1">
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </h6>
                <Checkbox
                  checked={value as boolean}
                  onChange={(e) =>
                    handleCheckboxChange("socialMedia", key, e.target.checked)
                  }
                  sx={{   color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },padding: 0 }}

                  
                />
              </div>
            ))}
        </div>
      </div>
      <div className="flex justify-end -mt-3">
        <Button 
        onClick={() => {
          handleClick("Company Profile Completeness"); // Replace someValue with the actual value you want to pass
          navigate(-1); // Navigate back
        }} 
        className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default CompanyProfile;
